var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v(_vm._s(_vm.selectedRows.length + " records selected"))]),
    _c("div", { staticClass: "action-selection" }, [
      _c("h5", [_vm._v("Select action type:")]),
      _c(
        "div",
        { staticClass: "action-options" },
        _vm._l(_vm.bulkActions, function (action, index) {
          return _c(
            "div",
            {
              key: index,
              class: [
                "action-option",
                {
                  selected: _vm.selectedActionIndex === index,
                  disabled: !action.enabled,
                },
              ],
              on: {
                click: function ($event) {
                  action.enabled && _vm.selectAction(index)
                },
              },
            },
            [
              _c("md-icon", [_vm._v(_vm._s(action.icon))]),
              _c("span", [_vm._v(_vm._s(action.name))]),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }